import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          © {currentYear} Big Break Snooker Club. All rights reserved.
        </p>
        <p className="footer-disclaimer">
          Website developed by <span className="coaldev-brand">Coaldev</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
